import { render } from "./ollaIndex.vue?vue&type=template&id=72fcae18&scoped=true"
import script from "./ollaIndex.vue?vue&type=script&lang=js"
export * from "./ollaIndex.vue?vue&type=script&lang=js"

import "./ollaIndex.vue?vue&type=style&index=0&id=72fcae18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fcae18"]])

export default __exports__